import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { BrowserUtils } from '@azure/msal-browser';

export default function SignOut() {
  const { instance } = useMsal();
  const { search } = useLocation();

  // When this component is triggered we want to force a *local* logout, i.e clear the user's login for the site.
  // We skip the global logout (redirect to Microsoft logout) by overriding the onRedirectNavigate property if this component is loaded in an iframe,
  // which indicates it is being done as part of a front-channel logout.
  // See: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/logout.md
  useEffect(() => {
    const queryString = new URLSearchParams(search);
    const sid = queryString.get('sid');

    const activeAccount = instance.getActiveAccount();
    let doLogout = false;
   
    // If we have a SID in the token claim, validate it against value in the querystring.

    if (activeAccount && activeAccount.idTokenClaims.sid) {
      if (activeAccount.idTokenClaims.sid === sid) {
        doLogout = true;
      }
    }

    if (doLogout) {
      instance.logoutRedirect({
        account: activeAccount,
        onRedirectNavigate: () => !BrowserUtils.isInIframe(),
      });
    }
  }, [instance]);

  return <div />;
}
